<template>
  <main class="main main--success success">
    <div class="gradient-bg" />
    <div class="group">
      <module-success
        :success-page="successPage" />
    </div>
  </main>
</template>

<script>
// Modules
import ModuleButton from "modules/Button";
import ModuleSuccess from "modules/Success";

// Image
const images = {
  tick: require(`images/dashboard/success-tick.svg`),
};

// Export
export default {
  name: `success`,

  // Components
  components: {
    ModuleButton,
    ModuleSuccess,
  },

  // Data
  data() {
    return {
      images,
      pages: {
        "patient-procedure": {
          title: `Procedure Submitted`,
          copy: [
            `Your request has been sent to your dentist’s office.`,
            `To ensure they get your information correct and fulfill your request, we suggest you call their office to confirm they got all the information needed and know you have consented to share your x-rays.`,
            `You will get an email update once they’ve uploaded your x-rays and again once an expert has completed a review.`,
          ],
          buttonLabel: `View My Dashboard`,
          buttonLink: `dashboard-requests`,
        },
        "patient-xray-upload": {
          title: `Procedure Details Submitted`,
          copy: [
            `Thank you.  You have successfully completed this request.`,
          ],
          buttonLabel: `View my dashboard`,
          buttonLink: `dashboard-requests`,
        },
        "doctor-xray-upload": {
          title: `Procedure Details Submitted`,
          copy: [
            `Thank you.  You have successfully completed your patient’s request.`,
            `VeriTooth is committed to helping dentist demonstrate quality by letting the work speak for itself.  In fact, if our reviewers see high quality work it can even be nominated for recognition and promotion on our social media channels.`,
          ],
          buttonLabel: `View my dashboard`,
          buttonLink: `dashboard-requests`,
        },
        "reviewer-xray-upload": {
          title: `Procedure Details Submitted`,
          copy: [
            `Thank you.  You have successfully completed your patient’s request.`,
            `VeriTooth is committed to helping dentist demonstrate quality by letting the work speak for itself.  In fact, if our reviewers see high quality work it can even be nominated for recognition and promotion on our social media channels.`,
          ],
          buttonLabel: `My Dashboard`,
          buttonLink: `dashboard`,
        },
        "reviewer-application": {
          title: `Your request is being processed`,
          copy: [
            `Thank you, your request to become a reviewer has been sent to VeriTooth. We will contact you shortly`,
          ],
          buttonLabel: `My Dashboard`,
          buttonLink: `dashboard`,
        },
        "reviewer-approved": {
          title: `Reviewer Approved`,
          copy: [
            `${
              this.$route.params.doctorName
            } has been added to the pool of reviewers`,
          ],
          buttonLabel: `View List of reviewer requests`,
          buttonLink: `admin-reviewer-requests`,
        },
        "reviewer-denied": {
          title: `Reviewer Denied`,
          copy: [
            `You have denied ${
              this.$route.params.doctorName
            } request to become a reviewer`,
          ],
          buttonLabel: `View List of reviewer requests`,
          buttonLink: `admin-reviewer-requests`,
        },
      },
    };
  },

  computed: {
    successPage() {
      return this.pages[this.$route.params.page] || {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// Success.vue?61bebe23